import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

// font awesome
const FAIcon = ({ className, lg, name, regular, solid, brand }) => (
  <i
    className={classnames({
      fab: brand,
      far: regular,
      fas: solid || (!regular && !brand),
      'fa-2x': lg,
    }, className, `fa-${name}`)}
  />
)

FAIcon.propTypes = {
  className: PropTypes.string,
  lg: PropTypes.bool,
  name: PropTypes.string.isRequired,
  regular: PropTypes.bool,
  solid: PropTypes.bool,
  brand: PropTypes.bool,
}
FAIcon.defaultProps = {
  className: '',
  lg: undefined,
  regular: false,
  solid: false,
  brand: false,
}

export default FAIcon
